import axios from 'axios';

import Auth from 'src/components/Auth/Auth';
import {
    IAuthUsersParams,
    IAuthUsersResponse,
    IAuthOrganizationsParams,
    IAuthOrganizationsResponse,
    IResponse
} from 'src/models';

export default {
    authComponent: null,

    dispose() {
        if (this.authComponent) {
            this.authComponent.dispose();
        }
        this.authComponent = null;
    },

    // 显示授权查看
    show(projectPuid: string) {
        if (!this.authComponent) {
            this.authComponent = new Auth({
                source: '<x-auth></x-auth>'
            });
            this.authComponent.attach(document.body);
        }
        this.authComponent.show(projectPuid);
    },

    // 获取项目授权查看用户列表
    getAuthUsers(params: IAuthUsersParams): Promise<IAuthUsersResponse> {
        return axios.get<IAuthUsersResponse>(`/api/projects/users-projects`, { params }).then(res => {
            return res.data;
        });
    },

    // 添加授权查看用户
    addAuthUsers(projectPuid: string, userIds: string[]): Promise<IResponse> {
        const data = {
            project_puid: projectPuid,
            user_ids: userIds,
        }
        return axios.post<IResponse>(`/api/projects/users-projects`, data).then(res => {
            return res.data;
        });
    },

    // 删除授权查看用户
    deleteAuthUser(projectPuid: string, userId: string): Promise<IResponse> {
        return axios.delete<IResponse>(`/api/projects/users-projects/${projectPuid}/${userId}`).then(res => {
            return res.data;
        });
    },

    // 获取项目授权查看组织列表
    getAuthOrganizations(params: IAuthOrganizationsParams): Promise<IAuthOrganizationsResponse> {
        return axios.get<IAuthOrganizationsResponse>(`/api/projects/organizations-projects`, { params }).then(res => {
            return res.data;
        });
    },

    // 添加授权查看组织
    addAuthOrganization(projectPuid: string, organizationId: string): Promise<IResponse> {
        const data = {
            project_puid: projectPuid,
            organization_id: organizationId,
        }
        return axios.post<IResponse>(`/api/projects/organizations-projects`, data).then(res => {
            return res.data;
        });
    },

    // 删除授权查看组织
    deleteAuthOrganization(projectPuid: string, organizationId: string): Promise<IResponse> {
        return axios.delete<IResponse>(`/api/projects/organizations-projects/${projectPuid}/${organizationId}`).then(res => {
            return res.data;
        });
    }
}
